import { render, staticRenderFns } from "./bidAnnouncementPublishDetail.vue?vue&type=template&id=86e64bca&scoped=true"
import script from "./bidAnnouncementPublishDetail.vue?vue&type=script&lang=js"
export * from "./bidAnnouncementPublishDetail.vue?vue&type=script&lang=js"
import style0 from "./bidAnnouncementPublishDetail.vue?vue&type=style&index=0&id=86e64bca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e64bca",
  null
  
)

export default component.exports